module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de_at":{"de_at":"Österreichisch","de_de":"Deutsch","en":"English","hu":"magyar","cs":"český","fr":"français"},"cs":{"de_at":"Österreichisch","de_de":"Deutsch","en":"English","hu":"magyar","cs":"český","fr":"français"},"hu":{"de_at":"Österreichisch","de_de":"Deutsch","en":"English","hu":"magyar","cs":"český","fr":"français"},"fr":{"de_at":"Österreichisch","de_de":"Deutsch","en":"English","hu":"magyar","cs":"český","fr":"français"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/LanguageSelect.vue
// module id = 1130
// module chunks = 0